export default __webpack_public_path__ + "static/media/flames.0f322b15.png";